import { TERMS } from "@aventuria/client-core/legal";
import { LegalDocumentPage } from "../components/LegalDocumentView";

/** Términos y Condiciones de Uso de la Plataforma. Public: accepted at registration. */
export function TermsPage() {
  return <LegalDocumentPage eyebrow="Términos y condiciones" document={TERMS} />;
}
